module.exports = __webpack_public_path__ + "static/media/facebook.7cb72e0b.png";